import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import { api } from "../ApiMapper/api"

function Subscriptions() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");


  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await api.get("/api/subscriptions");
        setSubscriptions(response.data ? [response.data] : []);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load subscriptions.");
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptions();
  }, []);

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Sidebar />
      <div className="flex-grow ml-64 p-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">My Subscriptions</h2>
        <div className="bg-white shadow-lg rounded-lg p-6">
          {loading ? (
            <p className="text-gray-600">Loading subscriptions...</p>
          ) : error ? (
            <p className="text-red-600">{error}</p>
          ) : subscriptions.length === 0 ? (
            <p className="text-gray-500">You have no active subscriptions.</p>
          ) : (
            <table className="w-full table-auto">
              <thead className="bg-blue-800 text-white">
                <tr>
                  <th className="px-4 py-2 text-left">Bot</th>
                  <th className="px-4 py-2 text-left">Start Date</th>
                  <th className="px-4 py-2 text-left">End Date</th>
                </tr>
              </thead>
              <tbody>
                {subscriptions.map((sub, index) => (
                  <tr key={index} className="even:bg-gray-100">
                    <td className="px-4 py-2">{sub.type}</td>
                    <td className="px-4 py-2">{sub.startDate}</td>
                    <td className="px-4 py-2">{sub.endDate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default Subscriptions;
